import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  }
});

// Add a simple log to confirm when the interceptor runs
axiosInstance.interceptors.request.use(
  config => {
    // Get the system from localStorage
    const selectedSystem = localStorage.getItem('@app-system');
    
    // If system is set, add it to the request
    if (selectedSystem) {
      // If query parameters already exists
      if (config.params) {
        config.params.systemType = selectedSystem;
      } else {
        // Create params object with system
        config.params = { systemType: selectedSystem };
      }
    }
    
    return config;
  },
  error => {
    console.error("Axios interceptor error:", error);
    return Promise.reject(error);
  }
);

export default axiosInstance;